import { IEvaluationTypeService } from "../../service/evaluation/EvaluationTypeService";

export default class ReleaseRuleGroupFromEvaluationTypeInteractor {
  private evaluationTypeService: IEvaluationTypeService;

  constructor(evaluationTypeService) {
    this.evaluationTypeService = evaluationTypeService;
  }

  async execute(evaluationTypeRuleGroupId: number) {
    return this.evaluationTypeService.releaseRuleGroup(
      evaluationTypeRuleGroupId
    );
  }
}
